import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Row, Form } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import PreviewImage from '../../../components/previewImage';

const twoCols = { xs: 12, md: 6 };
const threeCols = { xs: 6, md: 4 };

const Item = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  isSubmitting,
  imageSrc,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-play pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit(true)}>
              <Row>
                <Col md={9}>
                  <InputGroup
                    name="title"
                    label={t('Title')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.title}
                    icon="fa fa-building"
                    disabled
                  />
                  <InputGroup
                    name="animation_name"
                    label={t('Animation')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.animation_name}
                    icon="fa fa-building"
                    disabled
                  />
                  <InputGroup
                    name="animation_ratio"
                    label={t('Ratio')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.animation_ratio}
                    icon="fa fa-building"
                    disabled
                  />
                  <InputGroup
                    name="error"
                    type={'textarea'}
                    label={t('Error')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.error}
                    icon="fa fa-building"
                    disabled
                  />
                  <InputGroup
                    name="start_rendering_at"
                    label={t('start_rendering_at')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.start_rendering_at}
                    icon="fa fa-building"
                    disabled
                  />
                  <InputGroup
                    name="total_time"
                    label={t('Rendering time')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.total_time}
                    icon="fa fa-building"
                    disabled
                  />
                </Col>
                {/*<Col md={3}>*/}
                  {/*<div className="">*/}
                    {/*<PreviewImage src={imageSrc} className="" alt="img" height="120" />*/}
                  {/*</div>*/}
                {/*</Col>*/}
              </Row>
              <Row>
                <Col md={12}>
                  <Link className="btn btn-primary" to={'/videos'}>Back to video list</Link>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Item.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string.isRequired,
};

export default Item;



// WEBPACK FOOTER //
// ./src/views/videos/item/Item.jsx